import { BrowserRouter, Route, Routes } from "react-router-dom";
import Profile from "./Profile";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:code" element={<Profile />} />
        <Route path="/profile/:code" element={<Profile />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
